import HtmlRenderer from "../../HtmlRenderer";
import { useLanguage } from "../../hooks/useLanguage";
import React from "react";

const labels = {
  touristOffice: {
    da: "Turistkontor",
    en: "Tourist office",
    de: "Touristeninformation",
  },
  seeWebsite: {
    da: "Besøg hjemmeside",
    en: "See website",
    de: "Siehe Website",
  },
};

/*
 * This component displays the content of the tourist office sidebar
 */

export default function TouristOfficeSidebar(props: { feature: any }) {
  const language = useLanguage();
  if (!props.feature) return null;

  return (
    <div style={{ marginTop: 40 }}>
      <h3>{labels.touristOffice[language]}</h3>
      <div style={{ marginBottom: 20 }}>
        <HtmlRenderer html={props.feature.properties.TURISTKONT} />
      </div>
      <a
        href={`https://${props.feature.properties.LINK}`}
        target="_blank"
        rel="noopener noreferrer"
        style={{
          color: "white",
        }}
      >
        {labels.seeWebsite[language]}
      </a>
    </div>
  );
}
